<template lang="pug">
    v-container
        .header.d-flex.justify-space-between.align-center.mb-10.white--text
            h1 {{$t("tenant.title")}}
            CreateEditTenantDialog
            //- create-edit-user-dialog(:user="createUser" :edit="false")
        v-row(v-if="tenants && tenants.length > 0")
            v-col(v-for='tenant in tenants' :key='tenant.id' cols='12' md="6")
                v-card.elevation-25
                  v-card-text.d-flex.justify-space-between.flex-no-wrap

                    v-list-item(three-line='' style="margin-right: 130px;")
                      v-list-item-content
                        code.pt-1.text-normal
                          | {{tenant.id}}
                        v-list-item-title.headline.mb-1
                          | {{tenant.name}}
                    img.absoluteImage(v-if="tenant.branding" :src="tenant.branding.logoUrl")
                      

                  
                  v-card-subtitle
                    //- code {{tenant.branding}}
                  v-card-actions(v-if="tenant")
                        v-chip(:color="tenant.branding.primaryColor" v-if="tenant.branding && tenant.branding.primaryColor" dark) {{tenant.branding.primaryColor}}
                        v-chip.ml-2(:color="tenant.branding.accentColor" v-if="tenant.branding && tenant.branding.accentColor" dark) {{tenant.branding.accentColor}}
                        v-spacer
                        v-btn(depressed exact :to="{ name: 'tenantDetails', params: { tenantId: tenant.id }}")
                            | Details
                            v-icon.ml-2 arrow_forward
        v-row(v-else)
            v-col(v-for='(item, i) in 8', :key='i' cols='12' md="6")
                v-skeleton-loader.mb-2.elevation-25(  type="list-item-three-line, actions")
                            
                //- user-card(:user='user')
        
        

</template>

<script>
import { mapState } from "vuex";
import CreateEditTenantDialog from "@/components/admin/CreateEditTenantDialog.vue";
import date from "@/utils/date";

export default {
  components: {
    CreateEditTenantDialog,
  },
  data() {
    return {};
  },
  methods: {
    ...date,
  },
  computed: {
    ...mapState({ tenants: (state) => state.superAdmin.tenants }),
  },
  mounted() {
    this.$store.dispatch("superAdmin/FETCH_TENANTS");
  },
};
</script>

<style>
.borderLeft {
  border-left: 6px solid;
}
.absoluteImage {
  position: absolute;
  top: 20px;
  right: 20px;
  max-width: 100px;
}
</style>
